"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyLiveEditing = void 0;
var react_1 = require("react");
var config_1 = require("../../config");
/**
 * Subscribes to live-editing presence broadcasts for `selectedStrategyId` and
 * emits start/stop events whenever the local user holds unsaved changes.
 *
 * Self is excluded from the returned `liveEditors` list so the consumer can
 * render "other people editing" without filtering again.
 */
exports.useStrategyLiveEditing = function (selectedStrategyId, userEmail, hasUnsavedChanges) {
    var _a = react_1.useState([]), liveEditors = _a[0], setLiveEditors = _a[1];
    // Subscribe to editor-list broadcasts for the selected strategy
    react_1.useEffect(function () {
        if (!selectedStrategyId || !userEmail) {
            return undefined;
        }
        var socketClient = config_1.getSocketClient();
        var handleEditors = function (data) {
            if (data.strategyId !== selectedStrategyId)
                return;
            // P1-2: defense in depth — match self by both `id` and `email` so a
            // peer (or a compromised socket) cannot bypass the self-filter by
            // setting one field to a different value than the other. The server
            // is still the authority on identity; this only narrows the spoof
            // surface in the event the server forwards client-supplied fields.
            var selfMatch = function (e) {
                return e.id === userEmail || e.email === userEmail;
            };
            setLiveEditors(data.editors.filter(function (e) { return !selfMatch(e); }));
        };
        socketClient.strategyEditorsOn(handleEditors);
        return function () {
            socketClient.strategyEditorsOff(handleEditors);
            setLiveEditors([]);
        };
    }, [selectedStrategyId, userEmail]);
    // Emit editing presence based on whether the current user has unsaved changes
    react_1.useEffect(function () {
        if (!selectedStrategyId || !userEmail) {
            return undefined;
        }
        var socketClient = config_1.getSocketClient();
        if (hasUnsavedChanges) {
            socketClient.strategyEditingStart(selectedStrategyId, {
                id: userEmail,
                email: userEmail,
            });
        }
        else {
            socketClient.strategyEditingStop(selectedStrategyId);
        }
        return function () {
            socketClient.strategyEditingStop(selectedStrategyId);
        };
    }, [hasUnsavedChanges, selectedStrategyId, userEmail]);
    return { liveEditors: liveEditors };
};
